import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { EvaluacionMedicaRequest, EvaluacionMedicaResponse, ExpedienteEvaluacionMedicaResponse } from '../models/evaluacion-medica.interface';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EvaluacionMedicaService {

  constructor(private api: ApiService,private authService: BackendAuthService, private http: HttpClient, private sessionService: SessionService) { }

  async registrarEvaluacion(data: EvaluacionMedicaRequest): Promise<{ success: string, data: EvaluacionMedicaResponse }> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const http = this.http.post<{ success: string, data: EvaluacionMedicaResponse }>(
      `${environment.backendUrl}/esi-evaluacion-medica`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }

  async obtenerExpediente(expId: number): Promise<{ success: string, data: ExpedienteEvaluacionMedicaResponse }> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const http = this.http.post<{ success: string, data: ExpedienteEvaluacionMedicaResponse }>(
      `${environment.backendUrl}/esi-expediente-evaluacion-medica?exp_id=${expId}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }
}
